import styled from 'styled-components';

import { colorTokens } from '../variables';

export const Container = styled.div<{ size?: number; bgColor?: string }>`
  min-width: ${(props) => (props.size ? `${props.size}px` : '40px')};
  min-height: ${(props) => (props.size ? `${props.size}px` : '40px')};
  background-color: ${(props) => (props.bgColor ? `${props.bgColor}` : `${colorTokens.text.disabled}`)};
  text-align: center;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid ${colorTokens.text.contrast};
  margin-left: -7px;
  :first-of-type {
    outline: none;
    margin-left: 0;
  }
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Initials = styled.span<{ fontSize?: number }>`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '14px')};
  line-height: 20px;
  color: ${colorTokens.text.contrast};
  font-weight: 700;
`;
